import React from 'react';
import SortableTableHeader from '../../../CustomComponents/SortableTableHeader';

function PhysicianHeader(props) {
    const headers = [
        {
            id: 'last_name',
            label: 'Physician',
            tooltip: null,
            ratio: 14,
            minWidth: '150px',
            justify: 'start',
            sortable: true,
        },
        {
            id: 'progress',
            label: 'Physician Review Progress',
            tooltip: 'The progress of the physician review for all the included cards in the selected campaigns. The total opportunity here can vary from the original opportunity due to custom requests being made or recommendations being omitted during the physician review process.',
            ratio: 35,
            minWidth: '400px',
            justify: 'start',
            sortable: false,
        },
        {
            id: 'recommendation_summary.original_opportunity',
            label: 'Original Opportunity',
            tooltip: 'The initial annual projected savings value of all identified optimizations at the start of this campaign.',
            ratio: 12,
            minWidth: '130px',
            justify: 'start',
            sortable: true,
        },
        {
            id: 'approved_total',
            label: 'Approved',
            tooltip: 'The annual projected savings value of recommendations that have been accepted and routed for preference card updates (includes custom requests).',
            ratio: 12,
            minWidth: '130px',
            justify: 'start',
            sortable: true,
        },
        {
            id: 'recommendation_summary.rejected_value',
            label: 'Denied',
            tooltip: 'The annual projected savings value of recommendations that were explicitly rejected during review.',
            ratio: 12,
            minWidth: '130px',
            justify: 'start',
            sortable: true,
        },
        {
            id: 'recommendation_summary.open_value',
            label: 'Unreviewed',
            tooltip: 'The annual projected savings value of recommendations on preference cards that have not yet been opened or acted upon.',
            ratio: 15,
            minWidth: '140px',
            justify: 'start',
            sortable: true,
        },
        {
            id: 'recommendation_summary.omitted_value',
            label: 'Omitted',
            tooltip: 'The annual projected savings value of recommendations that were skipped or bypassed when other items on the same preference card were submitted.',
            ratio: 12,
            minWidth: '130px',
            justify: 'start',
            sortable: true,
        },
    ];

    return (
        <SortableTableHeader headers={headers} {...props} />
    );
}

export default PhysicianHeader;
